module.exports = __webpack_public_path__ + "static/media/cmr.e035486b.svg";